var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, forwardRef } from 'react';
import styled from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
import Label from '../Label/Label';
import Error from '../Error/Error';
const CheckboxContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.theme.spacings.halfSpacing};
`;
const CheckAndLabelContainer = styled.div `
  display: flex;
  align-items: center;
`;
const Icon = styled.svg `
  fill: none;
  stroke: white;
  stroke-width: 3px;
  display: block;
  margin: auto;
`;
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' }) `
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
const StyledCheckbox = styled.div `
  margin-right: 0.5rem;
  cursor: pointer;
  display: inline-block;
  border: ${props => props.isDisabled ? props.theme.utils.getColor('grey') : props.theme.utils.customBorders(props.color)};
  border-radius: 5px;
  width: 14px;
  height: 14px;
  transition: all 200ms;
  background-color: ${props => props.isDisabled
    ? props.theme.utils.getColor('grey')
    : props.checked
        ? props.theme.utils.getColor(props.color)
        : 'white'};

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;
const Checkbox = forwardRef((_a, ref) => {
    var { label, labelSize = 'note', register, name, isChecked = false, onClick = () => { }, onChange = () => { }, errors = {}, color = 'main', labelColor, isDisabled = false, value, skeleton, isLoading = false, isLoadingLabel = false, excludeMeFromLoadingContext = false } = _a, props = __rest(_a, ["label", "labelSize", "register", "name", "isChecked", "onClick", "onChange", "errors", "color", "labelColor", "isDisabled", "value", "skeleton", "isLoading", "isLoadingLabel", "excludeMeFromLoadingContext"]);
    const [checked, setChecked] = useState(false);
    const { loadingContext } = useCronoSkeleton();
    useEffect(() => {
        if (isChecked) {
            setChecked(true);
        }
        else if (!isChecked) {
            setChecked(false);
        }
    }, [isChecked]);
    const handleCheckboxChange = () => {
        if (!isDisabled) {
            onClick();
            setChecked(!checked);
            onChange(!checked);
        }
    };
    return (_jsxs(CheckboxContainer, Object.assign({}, props, { children: [_jsxs(CheckAndLabelContainer, { children: [_jsx(HiddenCheckbox, Object.assign({ ref: register, disabled: isDisabled, name: name, checked: checked, onChange: handleCheckboxChange, value: value, id: "provaCheckId" }, props)), (loadingContext && excludeMeFromLoadingContext === false) || isLoading
                        ? _jsx(Skeleton, Object.assign({ width: "16px" }, skeleton))
                        : _jsx(StyledCheckbox, Object.assign({ isDisabled: isDisabled, onClick: handleCheckboxChange, color: color, checked: checked }, { children: _jsx(Icon, Object.assign({ viewBox: "0 0 24 24" }, { children: _jsx("polyline", { points: "20 6 9 17 4 12" }) })) })), label &&
                        _jsx(Label, { isLoading: isLoadingLabel && ((loadingContext && excludeMeFromLoadingContext === false) || isLoading), skeleton: { margin: 'h', width: '30px', style: { top: '2px' } }, label: label, labelSize: labelSize, color: isDisabled ? 'grey' : labelColor || color, noMargin: true })] }), !!errors[name] &&
                _jsx(Error, { children: errors[name].message })] })));
});
export default Checkbox;
